import { useDialog } from "../../modernTS/JUI/Dialogs";
import { CreateUpsellDialog } from "./CreateUpsellDialog";
import React from "react";

export const NO_UPSELL_CREATED = Symbol("No upsell created");

export function useCreateUpsell() {
  const { createDialog, closeDialog } = useDialog();

  return () => {
    return new Promise((resolve, reject) => {
      createDialog({
        name: "add-new-upsell",
        maxWidth: "lg",
        fullSize: true,
        children: (
          <CreateUpsellDialog
            onCancel={() => {
              resolve(NO_UPSELL_CREATED);
              closeDialog("add-new-upsell");
            }}
          />
        ),
      });
    });
  };
}
